export class TemplateDto{
  public id?:number
  public descripcion?:string
  public nombre?:string
  public content?:string
}
